import styles from "./NavFooter.module.css";

export default function NavFooter({
  onBack,
  onNext,
  nextLabel = "Continue",
  disableNext = false,
  showBack = true,
  nextIcon = true,
}) {
  return (
    <div className={styles.root}>
      {showBack && onBack ? (
        <button className={styles.backBtn} onClick={onBack}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/>
          </svg>
          Back
        </button>
      ) : <div />}

      <button
        className={`${styles.nextBtn} ${disableNext ? styles.nextBtnDisabled : ""}`}
        onClick={onNext}
        disabled={disableNext}
      >
        {nextLabel}
        {nextIcon && (
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
          </svg>
        )}
      </button>
    </div>
  );
}
